<template>
  <CreationsList />
  <translation-modal v-if="translationModalState" />
</template>

<script>
import useModals from '~/composables/useModals';
import CreationsList from '~/components/myCreations/CreationsList.vue';
import TranslationModal from '~/components/conversation/translation/TranslationModal.vue';

export default {
  name: 'MyCreations',
  components: {
    CreationsList,
    TranslationModal,
  },
  setup() {
    const { translationModalState } = useModals();
    return {
      translationModalState,
    };
  },
};
</script>
